/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { ACTION_TYPES } from "../constants";

const useActionTypeCleaner = ({
	studentList, actionTypeList,
	studentReservationDetailIdsToDelete,
	dialogs
}) => {
	useEffect(() => {
        if (!studentList.existStudentsForTakeAttendance())
            actionTypeList.remove(ACTION_TYPES.TAKE_ATTENDANCE);
        if (studentReservationDetailIdsToDelete.length === 0)
            actionTypeList.remove(ACTION_TYPES.DELETE);
        if (!studentList.existStudentsNotSaved())
            actionTypeList.remove(ACTION_TYPES.ADD);
    }, dialogs.map(dialog => dialog.value));
}	
	
export default useActionTypeCleaner;